import { render } from "./BrowserDesktop.vue?vue&type=template&id=67c8a071&scoped=true"
import script from "./BrowserDesktop.vue?vue&type=script&lang=js"
export * from "./BrowserDesktop.vue?vue&type=script&lang=js"

import "./BrowserDesktop.vue?vue&type=style&index=0&id=67c8a071&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c8a071"]])

export default __exports__